import * as React from 'react';
import {Box, Typography} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import LinkTabs from "../Common/LinkTabs";
import RuleIcon from '@mui/icons-material/Rule';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import {getTabState} from "../../core/utils/utils";
import {useSelector} from "react-redux";
import {Outlet, useLocation} from "react-router";


const RULES_TAB = [
    {
        label: "Shop rules",
        //icon: <RuleIcon/>,
        path: "shop"
    },
    {
        label: "Accrual rules",
        //icon: <CurrencyExchangeIcon/>,
        path: "belcoins"
    },
    {
        label: "English Battle Pass",
        //icon: <CurrencyExchangeIcon/>,
        path: "xp"
    },
];
export default function RulesTabs() {
    const location = useLocation();
    let rulesTabState = getTabState(RULES_TAB, location.pathname)
    const sessionState = useSelector((state) => state.data.UserSession)
    const isUserHasAdminRole = sessionState.user.isAdmin;
    const isUserHasModeratorRole = sessionState.user.isManager;

    return (
        <Box>
            <LinkTabs
                tabState={"/shop"}
                tabs={RULES_TAB}
                state={rulesTabState}
                hideAdminTab={!isUserHasAdminRole}
                hideRequestTab={!isUserHasModeratorRole}
                hideSeniorityTab={true}
            />
            <Outlet/>
        </Box>

    );
}